import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showSearchBar } from '../../actions/HeaderActions';
import { searchText } from '../../actions/SearchActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import {Videos360} from '../../constants/videos';

class SearchPagefor360 extends Component {
    constructor(props) {
        super(props);
    };

    componentWillMount() {
        this.props.showSearchBar(true);
        this.clearText();
    }

    clearText() {
        this.props.searchText('');
    }

    componentWillUnmount() {

    }

    gotoViewAll(data){
        this.props.history.push('/videos/'+data.id);
    }

    mapCategoryList() {
        return (
            Videos360.map((e) => {
                return (
                    <li className="search-category-list__item" onClick={() => this.gotoViewAll(e)}>{e.name}</li>
                )
            })
        )
    }

    render(){
        return (
            <section className="search-page">
                <div className="search-page--es">
                    <ul className="list-unstyled search-category-list">
                        {this.mapCategoryList()}
                    </ul>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        header: state.HeaderReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        search: state.SearchReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        searchText,
        getVideoOrChannelRelatedData,
        showSearchBar
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPagefor360);



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPagefor360.js